import {
  SearchBar,
  SearchIcon,
} from '@trufla-technology/trumarket-react-design-system';
import { useState } from 'react';

type Props = {
  onSearch: (value: string) => void;
  placeholder?: string;
};

export const FilterForList = ({ onSearch, placeholder = 'Filter' }: Props) => {
  const [searchVal, setSearchVal] = useState<string>('');
  const handleSearchState = (value: string) => {
    setSearchVal(value);
    onSearch?.(value);
  };

  return (
    <SearchBar
      placeholder={placeholder}
      value={searchVal}
      onSearch={handleSearchState}
      icon={<SearchIcon fill="#54616C" />}
    />
  );
};
